import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { ProtectedRoute } from '@/components/ProtectedRoute'

// Pages
import { LoginPage } from '@/pages/LoginPage'
import { LogoutPage } from '@/pages/LogoutPage'
import { OrganizationsPage } from '@/pages/OrganizationsPage'
import { NewOrganizationPage } from '@/pages/NewOrganizationPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { AcceptInvitePage } from '@/pages/AcceptInvitePage'
import { DevicePage } from '@/pages/DevicePage'

// Assist pages
import { AssistPage } from '@/pages/AssistPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { SignalsPage } from '@/pages/SignalsPage'
import { SignalsCodePage } from '@/pages/SignalsCodePage'
import { SignalsModelsPage } from '@/pages/SignalsModelsPage'
import { DocsPage } from '@/pages/DocsPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { ProfilePage } from '@/pages/ProfilePage'
import { AnalyticsPage } from '@/pages/AnalyticsPage'

// Admin pages
import { AdminPage } from '@/pages/AdminPage'
import { AdminOverviewPage } from '@/pages/AdminOverviewPage'
import { AdminOrganizationsPage } from '@/pages/AdminOrganizationsPage'
import { AdminOrganizationEditPage } from '@/pages/AdminOrganizationEditPage'
import { AdminUsersPage } from '@/pages/AdminUsersPage'
import { AdminSettingsPage } from '@/pages/AdminSettingsPage'

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          <Route path="/device" element={<DevicePage />} />
          
          {/* Invite acceptance (works both logged in and out) */}
          <Route path="/invite/:token" element={<AcceptInvitePage />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            {/* Root redirect */}
            <Route path="/" element={<Navigate to="/organizations" replace />} />
            
            {/* Organization selection */}
            <Route path="/organizations" element={<OrganizationsPage />} />
            <Route path="/organizations/new" element={<NewOrganizationPage />} />

            {/* Organization-scoped assist routes */}
            <Route path="/:orgId/assist" element={<AssistPage />}>
              <Route index element={<DashboardPage />} />
              <Route path="signals" element={<SignalsPage />} />
              <Route path="signals/code" element={<SignalsCodePage />} />
              <Route path="signals/models" element={<SignalsModelsPage />} />
              <Route path="docs" element={<DocsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
            </Route>

            {/* Admin routes */}
            <Route path="/admin" element={<AdminPage />}>
              <Route index element={<AdminOverviewPage />} />
              <Route path="organizations" element={<AdminOrganizationsPage />} />
              <Route path="organizations/:orgId" element={<AdminOrganizationEditPage />} />
              <Route path="users" element={<AdminUsersPage />} />
              <Route path="settings" element={<AdminSettingsPage />} />
            </Route>
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  )
}
